import eight from '../assets/svg/projects/eight.svg'
import seven from '../assets/svg/projects/seven.svg'
import six from '../assets/svg/projects/six.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Suzanne Careers Solutions',
        projectDesc: 'This is a resume making plartform for a client.',
        tags: ['Recat Js', 'Node Js', 'Next Js', 'Tailwind CSS', 'MongoDB', 'Shadcn UI', 'AWS S3', 'Chat GPT API'],
        code: 'https://github.com/Langahoohlo/',
        demo: 'https://suzannescareersolutions.com/',
        image: six
    },
    {
        id: 2,
        projectName: 'CCtraders',
        projectDesc: 'A professional company website for a client.',
        tags: ['Python', 'Django', 'Tailwind CSS', 'PostgreSQL', 'REACT Js'],
        code: 'https://github.com/Langahoohlo/',
        demo: 'https://wwww.cctraders.co.ls',
        image: seven
    },
    {
        id: 3,
        projectName: 'Toca-organics',
        projectDesc: 'This is an e-commerce website for a company that I managed there online plartform.',
        tags: ['Recat Js', 'Node Js', 'Next Js', 'Tailwind CSS', 'PostgeSQL', 'Shadcn UI', 'AWS S3', 'Pay Lesotho API'],
        code: 'https://github.com/Langahoohlo/',
        demo: 'https://www.tocaskincare.com/',
        image: eight
    },
    {
        id: 4,
        projectName: 'Commonwealth Lesotho',
        projectDesc: 'Did community work for Commonwealth Lesotho, only Frontend work.',
        tags: ['CSS', 'Html', 'React Js'],
        code: 'https://github.com/Langahoohlo/',
        demo: 'https://www.cbwa-thelesothochapter.co.ls/',
        image: six
    },
    {
        id: 5,
        projectName: 'IIndulge Coffee',
        projectDesc: 'A coffee website testing my css skills.',
        tags: ['CSS', 'Html', 'Django','PotgreSQL'],
        code: 'https://github.com/Langahoohlo/coffee-website',
        demo: 'https://iindulge.vercel.app',
        image: seven
    },
    {
        id: 5,
        projectName: 'LIFTY-X',
        projectDesc: 'A social media site where you can post to meta services and linked wiht on esingle post.',
        tags: ['Shadcn UI', 'Tailwind', 'Next JS','PotgreSQL', 'Meta API', 'Linkedin oauth'],
        code: 'https://github.com/Langahoohlo/',
        demo: 'https://lifty-x.vercel.app/',
        image: seven
    },
    {
        id: 6,
        projectName: 'Matlo Lesotho',
        projectDesc: 'This is an app for real estate in Lesotho.',
        tags: ['Flutter', 'Firebase', 'Dart'],
        code: 'https://github.com/Langahoohlo/properties_app',
        demo: 'https://www.youtube.com/watch?v=4JYoNrud3oA&t=2s',
        image: six
    },
    {
        id: 7,
        projectName: 'Units App',
        projectDesc: 'This project was a school project to help students save unit notes on their phones.',
        tags: ['Flutter', 'Backendless'],
        code: 'https://github.com/Langahoohlo/units_app.git',
        demo: '',
        image: eight
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/